import React from "react";

import { LegacyIllustrations } from "../Illustration/LegacyIllustrations";
import { Text } from "../Text";

import styles from "./WidgetError.scss";

export interface WidgetErrorProps {
  text?: string;
}

/**
 * A component for displaying standard widget errors when viewing certain
 * visualization components.
 */
export function WidgetError({ text }: WidgetErrorProps) {
  const Illustration = LegacyIllustrations["Unplugged"];
  return (
    <div className={styles.wrapper}>
      <div
        className={styles["error-illustration"]}
        data-testid="error-illustration"
      >
        <Illustration />
      </div>
      {Boolean(text) && (
        <Text
          data-testid="error-text"
          className={styles["error-text"]}
          size="paragraphXsmall"
        >
          {text}
        </Text>
      )}
    </div>
  );
}
